import { render, staticRenderFns } from "./DeckEditorAddCardButton.vue?vue&type=template&id=5b961094&"
import script from "./DeckEditorAddCardButton.vue?vue&type=script&lang=js&"
export * from "./DeckEditorAddCardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports